import React, { Component } from 'react';
import { Checkbox, Grid, Table } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { every, filter, find, some, sortBy } from 'lodash';
import * as classnames from 'classnames';
import {
  createGroupParticipations,
  toggleAllActiveLayerParticipations,
  updateActiveLayerParticipations
} from '../../../data/analysis/participationsActions';
import GroupParticipation from './GroupParticipation';

class SamplingBox extends Component {
  constructor(props) {
    super(props);

    this.state = {
      colIndexSort: 0,
      reversed: false
    };

    this.setSortingCol = this.setSortingCol.bind(this);
    this.changeParticipationsHandler = this.changeParticipationsHandler.bind(this);
    this.toggleParticipantsHandler = this.toggleParticipantsHandler.bind(this);
    this.createGroupParticipations = this.createGroupParticipations.bind(this);
  }

  setSortingCol(colIndex) {
    const { colIndexSort, reversed } = this.state;
    this.setState({
      colIndexSort: colIndex,
      reversed: colIndexSort === colIndex ? !reversed : false
    });
  }

  changeParticipationsHandler(event, data) {
    const { dispatch } = this.props;
    dispatch(updateActiveLayerParticipations(data.value, data.checked));
  }

  toggleParticipantsHandler(event, data) {
    const { dispatch } = this.props;
    dispatch(toggleAllActiveLayerParticipations(data.checked));
  }

  createGroupParticipations() {
    const { project, dispatch } = this.props;
    if (project !== null) {
      dispatch(createGroupParticipations(project.id));
    }
  }

  render() {
    const { layer, participations, groupParticipations } = this.props;
    const { reversed } = this.state;
    const self = this;

    const participationsColumns = ['identifier', 'sex', 'birthyear'];

    /**
     * Sorting column generation
     * @type {any[]}
     */
    const sortingColumns = participationsColumns.map((col, i) => {
      const colClassNames = classnames({
        sorting: self.state.colIndexSort === i,
        reversed: self.state.reversed && self.state.colIndexSort === i
      });

      return (
        <Table.Cell key={`sortingParticipationColumn_${col}`} className={colClassNames}>
          <i
            className="icon icon-play3 clickable"
            onClick={() => {
              this.setSortingCol(i);
            }}
          />
        </Table.Cell>
      );
    });

    /**
     * Make basic participation object array
     */
    const filteredParticipations = filter(participations, participation => {
      return participation.status === 'valid';
    }).map(participation => {
      const checked =
        layer && layer.layer_participation_associations
          ? some(layer.layer_participation_associations, pAssociation => {
              return pAssociation.participation_id === participation.id;
            })
          : false;
      return {
        id: participation.id,
        identifier: participation.identifier,
        sex:
          participation.participant && participation.participant.sociodemo
            ? participation.participant.sociodemo.sex
            : null,
        birthyear:
          participation.participant && participation.participant.sociodemo
            ? participation.participant.sociodemo.birthyear
            : null,
        checked
      };
    });

    /**
     * Sort them by the selected column and map them as rows
     */
    let participationRows = sortBy(filteredParticipations, p => {
      return p[participationsColumns[self.state.colIndexSort]];
    }).map((p, i) => {
      const rowClassNames = classnames({
        odd: i % 2 === 0
      });

      return (
        <Table.Row key={`participationRow_${p.identifier}`} className={rowClassNames}>
          <Table.Cell>{p.identifier}</Table.Cell>
          <Table.Cell>{p.sex}</Table.Cell>
          <Table.Cell>{p.birthyear}</Table.Cell>
          <Table.Cell>
            <Checkbox
              onChange={this.changeParticipationsHandler}
              value={p.id}
              checked={p.checked}
            />
          </Table.Cell>
        </Table.Row>
      );
    });

    /**
     * Reverse check
     */
    if (reversed) {
      participationRows = participationRows.reverse();
    }

    const mappedGroupParticipations = groupParticipations.map((groupParticipation, index) => {
      return (
        <GroupParticipation
          key={`groupParticipation_${groupParticipation.name}`}
          layer={layer}
          participations={participations}
          groupParticipation={groupParticipation}
        />
      );
    });

    const allChecked = every(filteredParticipations, { checked: true });

    return (
      <Grid>
        <Grid.Row className="samplingList">
          <Grid.Column>
            <Table>
              <Table.Header>
                <Table.Row className="sortingRow">
                  {sortingColumns}
                  <Table.Cell>
                    <Checkbox onClick={this.toggleParticipantsHandler} checked={allChecked} />
                  </Table.Cell>
                </Table.Row>
              </Table.Header>
              <Table.Body>{participationRows}</Table.Body>
            </Table>
          </Grid.Column>
        </Grid.Row>
        {mappedGroupParticipations}
        <Grid.Row className="addGroup clickable" onClick={this.createGroupParticipations}>
          <Grid.Column width={2} className="iconContainer">
            <i className="icon icon-plus" />
          </Grid.Column>
          <Grid.Column width={14}>New Group</Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}

export default connect(state => ({
  project: state.projects.single.active,
  participations: state.analysis.single.participations,
  groupParticipations: state.analysis.single.groupParticipations,
  layer: (() => {
    const { activeLayerId } = state.analysis.single;
    return find(state.analysis.single.layers, { id: activeLayerId });
  })()
}))(SamplingBox);



// WEBPACK FOOTER //
// ./src/scenes/analysis/components/analysis/parameters/SamplingBox.js